<template>
  <div class="pic_slide_mn">
    <!--图片切换----开始-->

    <el-carousel arel-row="hover" :autoplay="false" height="390px">
<!--        <el-carousel-item class="pic_0">-->
<!--          <img :src="require('@/assets/pcimages/slide_text_mn5.png')" data-aos-once="true"  data-aos="flip-left"  aos-anchor-placement="center-center" />-->
<!--        </el-carousel-item>-->

        <el-carousel-item class="pic_1">

          <el-row type="flex" justify="center" align="middle">

            <el-col :span="12">

              <p class="mw">ᠣᠶᠤᠨ OCR ᠱᠢᠰᠲ᠋ᠧᠮ</p>

              <span data-aos-once="true"   data-aos="fade-down-left" data-aos-easing="ease" data-aos-delay="600"><span class="mw">ᠴᠠᠭᠠᠨ ᠲᠢᠭ᠂ ᠬᠠᠷ᠎ᠠ ᠲᠢᠭ᠂ ᠭᠠᠷᠴᠠᠭ ᠲᠢᠭ᠂ ᠰᠣᠨᠢᠨ ᠲᠢᠭ ᠪᠠ ᠬᠠᠸᠠᠨᠭ ᠲᠢᠭ ᠢ᠋ᠶ᠋ᠡᠷ ᠬᠡᠪᠯᠡᠭᠰᠡᠨ ᠨᠣᠮ ᠪᠢᠴᠢᠭ᠂ ᠰᠣᠨᠢᠨ ᠰᠡᠳᠭᠦᠯ᠂ ᠰᠦᠯᠵᠢᠶᠡᠨ ᠵᠢᠷᠤᠭ ᠪᠠ PDF ᠵᠡᠷᠭᠡ ᠪᠢᠴᠢᠭ  ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠢ᠋  ᠢᠯᠭᠠᠨ ᠲᠠᠨᠢᠵᠤ ᠳᠡᠢᠯᠦᠨ᠎ᠡ᠃</span></span>

              <a data-aos-once="true"  data-aos="fade-down-left" data-aos-easing="ease" data-aos-delay="800" class="mw" href="http://ocr.mglip.com/user_login.action" target="_blank">ᠲᠤᠷᠰᠢᠨ ᠬᠡᠷᠡᠭᠯᠡᠬᠦ </a>

            </el-col>

            <el-col :span="12">

              <img :src="require('@/assets/pcimages/slide_1_2.png')" data-aos-once="true"  data-aos="fade-down-left" data-aos-easing="ease" />

              <img :src="require('@/assets/pcimages/slide_1_1.png')" data-aos-once="true"  data-aos="fade-up-right" data-aos-easing="ease" />
            </el-col>
          </el-row>
        </el-carousel-item>
        <el-carousel-item class="pic_2">
          <div>
            <p class="mw">ᠣᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠦ ᠣᠶᠤᠨᠴᠢ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠳᠤ ᠬᠦᠴᠦᠯᠡᠨ ᠴᠢᠷᠮᠠᠢᠵᠤ      ᠣᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠦ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ᠎ᠶᠢ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠬᠢᠷᠢ ᠲᠦᠪᠰᠢᠨ᠎ᠢ ᠳᠡᠭᠡᠭᠰᠢᠯᠡᠭᠦᠯᠬᠦ᠎ᠳᠦ ᠬᠦᠴᠦᠨ ᠨᠡᠮᠡᠷᠢᠭᠦᠯᠦᠶ᠎ᠡ！</p>
          </div>
          <div class="divider">
            <span></span>
            <div data-aos-once="true"  data-aos="flip-left" data-aos-delay="100" data-aos-anchor=".pic_1"><span class="mw">ᠣᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠪᠠ ᠬᠠᠮᠢᠶ᠎ᠠ ᠪᠦᠬᠦᠢ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠤᠨ ᠨᠡᠬᠡᠭᠡᠯᠲᠡ</span></div>
            <span></span>
          </div>

        </el-carousel-item>

        <el-carousel-item class="pic_3">
          <div>
            <p class="mw">
              《ᠤᠶᠤᠨ》ᠤᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠨᠡᠭᠡᠭᠡᠯᠲᠡ ᠲᠠᠪᠴᠠᠩ ᠨᠢ ᠬᠡᠷᠡᠭᠯᠡᠭᠴᠢᠳ᠎ᠲᠦ ᠤᠯᠠᠨ ᠬᠡᠯᠡ᠎ᠶᠢ  ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠲᠤᠬᠠᠢ ᠦᠨᠳᠦᠷ ᠠᠰᠢᠭᠯᠠᠮᠵᠢᠲᠤ ᠵᠠᠯᠭᠠᠭᠠᠰᠤ ᠬᠠᠩᠭᠠᠵᠤ ᠂ ᠤᠯᠠᠨ ᠬᠡᠯᠡᠨ᠎ᠤ ᠵᠠᠩᠭᠢᠵᠢᠯᠠᠯᠲᠠ᠎ᠶᠢ ᠬᠠᠮᠲᠤ ᠪᠡᠷ ᠲᠦᠯᠬᠢᠨ ᠠᠭᠢᠭᠤᠯᠬᠤ᠎ᠶᠢ ᠵᠣᠷᠢᠵᠤ ᠪᠠᠢᠨ᠎ᠠ᠃ ᠲᠤᠰ ᠲᠠᠪᠴᠠᠩ ᠤᠯᠠᠨ ᠲᠦᠷᠦᠯ᠎ᠤᠨ ᠦᠭᠡ ᠬᠡᠯᠡ ᠦᠰᠦᠭ ᠪᠢᠴᠢᠭ ᠰᠢᠢᠳᠪᠦᠷᠢᠯᠡᠬᠦ ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ᠎ᠶᠢ ᠪᠠᠭᠲᠠᠭᠠᠵᠤ ᠂ ᠲᠤᠰᠭᠠᠢᠴᠢᠯᠠᠭᠰᠠᠨ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠤᠨ ᠳᠡᠮᠵᠢᠯᠭᠡ ᠂ ᠮᠡᠷᠭᠡᠵᠢᠯ᠎ᠤᠨ ᠲᠣᠪᠬᠢᠮᠠᠯ ᠬᠠᠩᠭᠠᠵᠤ᠂ ᠲᠠᠨ᠎ᠤ ᠨᠡᠭᠡᠭᠡᠯᠲᠡ᠎ᠶᠢᠨ ᠨᠡᠬᠡᠭᠡᠯᠲᠡ᠎ᠶᠢᠨ ᠦᠷ᠎ᠡ ᠠᠰᠢᠭ᠎ᠢ ᠳᠡᠭᠡᠭᠰᠢᠯᠡᠭᠦᠯᠳᠡᠭ ᠶᠤᠮ᠃
            </p>
          </div>

        </el-carousel-item>

        <el-carousel-item class="pic_4">

          <el-row type="flex" justify="center" align="middle">

            <el-col :span="12">

              <img :src="require('@/assets/pcimages/slide_4_pic.png')" data-aos="fade-down-left" data-aos-easing="ease" />

            </el-col>

            <el-col :span="12">
              <p class="mw"> ᠮᠤᠨᠭᠭᠤᠯ ᠭᠠᠷ ᠪᠢᠴᠢᠮᠡᠯ ᠲᠢᠭ ᠪᠠ ᠮᠤᠨᠭᠭᠤᠯ ᠠᠪᠢᠶ᠎ᠠ ᠶ᠋ᠢ ᠲᠠᠨᠢᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ ᠲᠠᠢ ᠣᠶᠤᠨᠲᠤ ᠦᠰᠦᠭ ᠣᠷᠣᠭᠤᠯᠬᠤ ᠠᠷᠭ᠎ᠠ
              </p>
              <span data-aos="fade-up" data-aos-easing="ease" data-aos-delay="600">
                <ul class="mw">
                  <li>ᠮᠤᠨᠭᠭᠤᠯ ᠦᠰᠦᠭ᠎ᠤᠨ ᠭᠠᠷ ᠪᠢᠴᠢᠮᠡᠯ ᠲᠢᠭ ᠢ᠋ ᠲᠠᠨᠢᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ</li>
                  <li>ᠮᠣᠩᠭᠣᠯ ᠦᠰᠦᠭ᠎ᠢ ᠪᠠᠯᠠᠷᠬᠠᠢ ᠪᠢᠴᠢᠭᠯᠡᠬᠦ ᠴᠢᠳᠠᠮᠵᠢ</li>
                  <li>ᠮᠤᠨᠭᠭᠤᠯ ᠬᠡᠯᠡᠨ᠎ᠦ ᠠᠪᠢᠶ᠎ᠠ ᠲᠠᠨᠢᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ</li>
                  <li>ᠳᠠᠭᠠᠪᠤᠷᠢ ᠶ᠋ᠢ ᠣᠶᠤᠨᠴᠢ ᠬᠠᠨᠭᠭᠠᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ</li>
                  <li> ᠮᠤᠨᠭᠭᠤᠯ ᠬᠡᠯᠡᠨ᠎ᠦ ᠬᠣᠯᠪᠣᠭ᠎ᠠ ᠦᠭᠡ ᠬᠣᠯᠪᠣᠨ ᠪᠣᠳᠣᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ</li>
                  <li>ᠳᠦᠷᠰᠦ ᠢᠵᠢᠯ ᠦᠰᠦᠭ᠎ᠤᠨ ᠣᠶᠤᠨᠴᠢ ᠥᠷᠭᠡᠳᠭᠡᠬᠦ ᠴᠢᠳᠠᠮᠵᠢ</li>
                </ul>
              </span>
              <a data-aos="fade-up" data-aos-easing="ease" data-aos-delay="800" href="mn_download.html"><img :src="require('@/assets/pcimages/dowmload_btn_mn.png')" /></a>

            </el-col>

          </el-row>

        </el-carousel-item>
<!--      <el-carousel-item class="pic_6">-->
<!--        <el-row type="flex" justify="center" align="middle">-->
<!--          <el-col>-->
<!--            <p data-aos="fade-up" data-aos-easing="ease" data-aos-delay="600">ᠣᠶᠤᠨ ᠲᠣᠮᠣ᠌ ᠵᠠᠭᠪᠤᠷ </p>-->
<!--            <span data-aos="fade-up" data-aos-easing="ease" data-aos-delay="800">ᠢᠯᠡ᠎ᠪᠡᠷ ᠲᠤᠷᠰᠢᠬᠤ ᠬᠡᠪ </span>-->
<!--            <div class="subtitle" data-aos-once="true"  data-aos="slide-left" data-aos-delay="100">ᠮᠣᠩᠭᠣᠯ  ᠪᠢᠴᠢᠭ ᠎ᠲᠦ  ᠰᠠᠭᠤᠷᠢᠯᠠᠵᠤ-->
<!--              ᠪᠣᠯᠪᠠᠰᠤᠷᠠᠭᠤᠯᠤᠭᠰᠠᠨ  ᠲᠣᠮᠤ ᠬᠡᠯᠡᠨ᠎ᠦ-->
<!--              ᠵᠠᠬᠪᠤᠷ</div>-->
<!--            <el-button type="primary" @click="toOyunChat">ᠬᠡᠷᠡᠭᠯᠡᠬᠦ</el-button>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-carousel-item>-->


    </el-carousel>

  </div>
</template>
<script>
export default {
  methods:{
    toOyunChat(){
      window.open('https://chat.nmgoyun.com/','_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.pic_1{
  background: url('../../assets/pcimages/slide_bg_1.png')no-repeat top;
  .el-row--flex{
    background: url('../../assets/pcimages/slide_bg_1_1.png') no-repeat 80%;

  }
}
.pic_3 {
  background: url('../../assets/pcimages/slide_bg_3.png')no-repeat top;
}

.pic_4 {
  background: url('../../assets/pcimages/slide_bg_4.png')no-repeat top;
  span{
    ul{
      li{
        background: url('../../assets/download/pic4_dot.png') no-repeat top;
      }
    }
  }
}
.pic_2 {
  background: url('../../assets/pcimages/slide_bg_2.png')no-repeat top;
  display: flex;
  flex-flow: column;
  align-items: center;
}
.pic_6 {
  background: url('../../assets/pcimages/offclSlider5.png')no-repeat top;
}
</style>



// WEBPACK FOOTER //
// src/layoutMN/components/slider.vue